// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"requested-collections_routeHeader_25pEI","addButton":"requested-collections_addButton_2O4Qe"};